"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationLogsRpcClient = void 0;
exports.ApplicationLogsRpcMixin = ApplicationLogsRpcMixin;
const Query_1 = __importDefault(require("../Query"));
const RpcDispatcher_1 = require("./RpcDispatcher");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function ApplicationLogsRpcMixin(base) {
    return class extends base {
        async getApplicationLog(blockOrTxHash) {
            return await this.execute(Query_1.default.getApplicationLog(blockOrTxHash));
        }
    };
}
class ApplicationLogsRpcClient extends ApplicationLogsRpcMixin(RpcDispatcher_1.RpcDispatcher) {
    get [Symbol.toStringTag]() {
        return `ApplicationLogsRpcClient(${this.url})`;
    }
}
exports.ApplicationLogsRpcClient = ApplicationLogsRpcClient;
